import gql from 'graphql-tag';

export const LEAD_MUTATION= gql`
  mutation saveLead($lead: LeadInput!) {
    saveLead(lead: $lead) {
      id
     }
  }
`;
